import React from 'react';
import PropTypes from 'prop-types';
import { Exclamation } from '../../../../assets/images';

import {
  BoxError,
  StyledError,
  StyledIconError,
  StyledInput,
  StyledTextArea,
  StyledInputBox,
  StyledErrorTitle
} from './style';

const Input = ({
  className,
  error,
  errorTitle,
  multiline,
  onChange,
  id,
  name,
  type,
  placeholder,
  valid,
  ...rest
}) => {
  const handleOnChange = event => {
    if (onChange) {
      onChange(event.target.value, event);
    }
  };

  const input = (
    <StyledInputBox className={className} {...rest}>
      <StyledInput
        onChange={e => handleOnChange(e)}
        name={name}
        id={id}
        type={type}
        placeholder={placeholder}
        valid={valid}
        error={!errorTitle && error}
        errorTitle={errorTitle}
        {...rest}
      />
      <BoxError>
        {(error || errorTitle) && (
          <StyledErrorTitle title={error || errorTitle}>
            <StyledIconError size="s" color="error" svg={Exclamation} />
          </StyledErrorTitle>
        )}
        {error && <StyledError>{error}</StyledError>}
      </BoxError>
    </StyledInputBox>
  );

  const textarea = (
    <StyledInputBox className={className} {...rest}>
      <StyledTextArea
        onChange={handleOnChange}
        id={id}
        error={error}
        errorTitle={errorTitle}
        {...rest}
        name={name}
        placeholder={placeholder}
        valid={valid}
      />
      <BoxError>
        {(error || errorTitle) && (
          <StyledErrorTitle title={error || errorTitle}>
            <StyledIconError size="s" color="error" svg={Exclamation} />
          </StyledErrorTitle>
        )}
        {error && <StyledError>{error}</StyledError>}
      </BoxError>
    </StyledInputBox>
  );
  return multiline ? textarea : input;
};

Input.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  errorTitle: PropTypes.string,
  height: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  maxLength: PropTypes.number,
  multiline: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.number,
  size: PropTypes.number,
  type: PropTypes.oneOf([
    'button',
    'email',
    'number',
    'password',
    'text',
    'file'
  ]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.string,
  valid: PropTypes.bool
};

Input.defaultProps = {
  disabled: false,
  multiline: false,
  required: false,
  type: 'text',
  valid: true
};

export default Input;
